

































































import Vue from 'vue';
import { VMenu, VColorPicker } from 'vuetify/lib';
export default Vue.extend({
  components: { VMenu, VColorPicker },
  props: {
    type: {
      required: false,
      type: String,
      default: 'input'
    },
    colorPickerWidth: {
      required: false,
      type: String,
      default: '360px'
    },
    value: {
      required: true,
      type: [String, Number]
    },
    colors: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    showMenu: false,
    parentWidth: ''
  }),
  methods: {
    handleInputClick() {
      const parentEl: any = this.$refs.refs_selector;
      // if (parentEl?.offsetWidth) {
      this.parentWidth = parentEl.offsetWidth + 'px';
      // }
    },
    handleSelected(color: string) {
      this.$emit('input', color);
      this.showMenu = false;
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
});
